import React from 'react';
import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor } from '../../client';
import { profile } from '../../data/portfolioContent';
import './About.scss';

const About = () => {
  return (
    <>
      <h2 className="head-text">
        Running On A <sup><del className="line">Binary</del></sup> Ternary System:
        <br />
        <span>Bytes</span>, <span>Pexels</span> And <span>Tunes</span>
      </h2>
      <div className="app__profiles">
        <motion.div
          whileInView={{ opacity: 1 }}
          className="app__profile-item"
        >
          <motion.img
            whileHover={{ scale: 0.96 }}
            transition={{ duration: 0.5, type: 'tween' }}
            src={urlFor(profile.image).rect(140, 160, 760, 700).width(620).height(620).fit('crop').url()}
            alt="Abubakr Ahmed"
          />
          <p className="app__about-summary">{profile.summary}</p>
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);
